import {
  Document,
  Image,
  Line,
  Page,
  Path,
  StyleSheet,
  Svg,
  Text,
  View,
} from "@react-pdf/renderer";
import { renderEUDate, renderEUTime } from "../../../utils/utils";
import logoH3K from "../../../logos/health3000_logo.png";

const DoneIcon = () => {
  return (
    <Svg width="24px" height="24px">
      <Path
        d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
        stroke="rgb(0, 255, 0)"
        strokeWidth={2}
      />
    </Svg>
  );
};
const CloseIcon = () => {
  return (
    <Svg width="24px" height="24px">
      <Path
        d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        stroke="rgb(255, 0, 0)"
        strokeWidth={2}
      />
    </Svg>
  );
};

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 15,
    fontSize: 11,
  },
  pageNumbers: {
    position: "absolute",
    bottom: 10,
    right: 10,
    textAlign: "center",
  },

  // title view
  spaceBetween: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#3E3E3E",
  },

  h3k_logo_and_text: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    // maxWidth: 250,
    // maxHeight: 40,
  },

  title_view: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  title_view_text: {
    fontWeight: 900,
    fontSize: 13,
  },
  title_view_image_header: {
    width: 100,
  },
  title_view_image: {
    position: "absolute",
    bottom: 5,
    left: 10,
    right: 10,
    width: 100,
  },

  // table
  table: {
    width: "100%",
  },
  table_title: {
    fontWeight: 800,
    fontSize: 16,
    marginTop: 20,
    marginBottom: 20,
    textAlign: "center",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    paddingTop: 8,
    fontSize: 12,
    paddingBottom: 8,
  },
  header: {
    borderTop: "none",
  },
  bold: {
    fontWeight: 800,
  },
  row_patient: {
    width: "25%",
  },
  row_time: {
    width: "10%",
  },
  row_temperature: {
    width: "13%",
  },
  row_psis: {
    width: "13%",
  },
  row_pdia: {
    width: "13%",
  },
  row_hr: {
    width: "5%",
  },
  row_spo2: {
    width: "7%",
  },
  row_alert: {
    width: "7%",
  },
  row_org_id: {
    width: "5%",
  },
});

const isOutOfBounds = (row, key) => {
  const red = {
    color: "red",
  };

  if (key === null) {
    return row.isOutOfBounds ? red : {};
  }

  return row[key] ? red : {};
};

const getDayData = (day, data) => {
  let _day = new Date(day).getDate();
  return data.filter((row) => {
    return new Date(row.date).getDate() === _day;
  });
};

const clientHeaderPart = (logo) => {
  console.log(logo);
  if (logo == null || logo == undefined || (logo && logo.length == 0)) {
    return <></>;
  }

  return (
    <Image
      style={styles.title_view_image_header}
      src={
        logo == null || logo == undefined || (logo && logo.length == 0)
          ? ""
          : logo
      }
    />
  );
};

const MainHeader = ({ logoInfo, orgInfo }) => {
  let { includeH3K, logo, clientLogoPos } = logoInfo;
  if (
    clientLogoPos == null ||
    clientLogoPos == undefined ||
    (clientLogoPos && clientLogoPos.length == 0)
  ) {
    clientLogoPos = "DX";
  }

  let { org_name, address, cap, city } = orgInfo;

  if (!org_name) {
    console.log("not org name");
    return <></>;
  }

  let info = `${org_name}`;
  if (city && address && cap) {
    info += `- ${address} ${cap} - ${city}`;
  }

  console.log("info");

  let imgStyle = clientLogoPos == "DX" ? { marginLeft: 450 } : {};

  return (
    <View
      style={{ padding: 5, display: "flex", flexDirection: "column" }}
      fixed
    >
      <View style={imgStyle}>{clientHeaderPart(logo)}</View>

      <View style={{ fontSize: 9, justifyContent: "flex-start" }}>
        <Text>{info}</Text>
      </View>
    </View>
  );
};

const Divider = () => {
  return (
    <Svg height="2" width="575">
      <Line
        x1="0"
        y1="0"
        x2="570"
        y2="0"
        strokeWidth={0.5}
        stroke="rgb(0,0,0)"
      />
    </Svg>
  );
};

const MainFooter = ({ logoInfo, pageNumber, totalPages }) => {
  let { includeH3K, logo, clientLogoPos } = logoInfo;
  console.log(logoInfo);
  if (includeH3K == null || includeH3K == undefined) {
    includeH3K = true;
  }

  return (
    <View style={styles.title_view}>
      <View style={styles.h3k_logo_and_text}>
        <Image
          style={[styles.title_view_image, !includeH3K && { display: "none" }]}
          src={logoH3K}
        />
        <Text
          style={[styles.title_view_text, !includeH3K && { display: "none" }]}
        >
          {!includeH3K ? "" : "Instant Connection"}
        </Text>
      </View>
      <Text>
        Pag. {pageNumber} / {totalPages}
      </Text>
    </View>
  );
};

const NoData = ({ orgInfo }) => {
  const h = orgInfo.org_name.length == 0 ? 720 : 700; // 720 is good without header
  return (
    <View>
      <Text>Nessuna misurazione registrata.</Text>
    </View>
  );
};

const TableHeader = () => {
  return (
    <View style={[styles.row, styles.bold, styles.header]}>
      <Text style={styles.row_patient}>Paziente</Text>
      <Text style={styles.row_time}>Ora</Text>
      <Text style={styles.row_temperature}>Temp. (°C)</Text>
      <Text style={styles.row_psis}>P. Sistolica</Text>
      <Text style={styles.row_pdia}>P. Diastolica</Text>
      <Text style={styles.row_hr}>HR</Text>
      <Text style={styles.row_spo2}>SPO2</Text>
      <Text style={styles.row_alert}>Alert</Text>
      {/* <Text style={styles.row_org_id}>OrgID</Text> */}
    </View>
  );
};

const TableRow = ({ row, key }) => {
  return (
    <View key={key} style={styles.row} wrap={false}>
      <Text style={[styles.row_patient, isOutOfBounds(row, null)]}>
        {row.first_name} {row.last_name}
      </Text>
      <Text style={styles.row_time}>{renderEUTime(row.date)}</Text>
      <Text
        style={[styles.row_temperature, isOutOfBounds(row, "Temperature_ofb")]}
      >
        {row.Temperature}
      </Text>
      <Text style={[styles.row_psis, isOutOfBounds(row, "Pmax_ofb")]}>
        {row.Pmax}
      </Text>
      <Text style={[styles.row_pdia, isOutOfBounds(row, "Pmin_ofb")]}>
        {row.Pmin}
      </Text>
      <Text style={[styles.row_hr, isOutOfBounds(row, "HR_ofb")]}>
        {row.HR}
      </Text>
      <Text style={[styles.row_spo2, isOutOfBounds(row, "SpO2_ofb")]}>
        {row.SpO2}
      </Text>
      {row.alert ? <CloseIcon /> : <DoneIcon />}
    </View>
  );
};

export const ReportTable = ({ data, days, logoInfo, orgInfo }) => {
  let { includeH3K, logo, clientLogoPos } = logoInfo;
  console.log(logoInfo);
  if (includeH3K == null || includeH3K == undefined) {
    includeH3K = true;
  }
  return (
    <Document>
      {days.map((day, i) => (
        <Page size="A4" style={styles.page}>
          <MainHeader logoInfo={logoInfo} orgInfo={orgInfo} />
          <View key={i} style={styles.table}>
            <Text style={styles.table_title}>
              Daily Report del {renderEUDate(day)}
            </Text>
            {getDayData(day, data).length == 0 ? (
              <NoData orgInfo={orgInfo} />
            ) : (
              <>
                <TableHeader />
                {getDayData(day, data).map((row, j) => (
                  <TableRow key={j} row={row} />
                ))}
              </>
            )}
          </View>
          <View
            style={{
              position: "absolute",
              width: 565,
              height: 25,
              fontSize: 11,
              bottom: 5,
              left: 10,
              right: 10,
              textAlign: "center",
              color: "grey",
            }}
            render={({ pageNumber, totalPages }) => (
              <>
                <Divider />
                <Text
                  style={{
                    display: !includeH3K ? "none" : "inherit",
                    fontSize: 11,
                    position: "absolute",
                    bottom: 5,
                    left: 120,
                  }}
                >
                  {!includeH3K ? "" : "Instant Connection"}
                </Text>
                <Text
                  style={{
                    position: "absolute",
                    bottom: 5,
                    right: 10,
                    fontSize: 11,
                  }}
                >
                  Pag. {pageNumber} / {totalPages}
                </Text>
              </>
            )}
            fixed
          />
          <Image
            fixed
            style={[
              styles.title_view_image,
              !includeH3K && { display: "none" },
            ]}
            src={logoH3K}
          />
        </Page>
      ))}
    </Document>
  );
};
